import { render } from "./SubCategories.vue?vue&type=template&id=2983cb76&scoped=true"
import script from "./SubCategories.vue?vue&type=script&lang=js"
export * from "./SubCategories.vue?vue&type=script&lang=js"

import "./SubCategories.vue?vue&type=style&index=0&id=2983cb76&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2983cb76"]])

export default __exports__